import IMG_STORE_APPLE_KO from '~/assets/images/stores/store-apple.ko.png';
import IMG_STORE_APPLE_EN from '~/assets/images/stores/store-apple.en.png';
import IMG_STORE_APPLE_JA from '~/assets/images/stores/store-apple.ja.png';
import IMG_STORE_APPLE_ZH from '~/assets/images/stores/store-apple.zh-hant.png';
import IMG_STORE_APPLE_TH from '~/assets/images/stores/store-apple.th.png';
import IMG_STORE_APPLE_DE from '~/assets/images/stores/store-apple.de.png';
import IMG_STORE_APPLE_FR from '~/assets/images/stores/store-apple.fr.png';
import IMG_STORE_GOOGLE_KO from '~/assets/images/stores/store-google.ko.png';
import IMG_STORE_GOOGLE_EN from '~/assets/images/stores/store-google.en.png';
import IMG_STORE_GOOGLE_JA from '~/assets/images/stores/store-google.ja.png';
import IMG_STORE_GOOGLE_ZH from '~/assets/images/stores/store-google.zh-hant.png';
import IMG_STORE_GOOGLE_TH from '~/assets/images/stores/store-google.th.png';
import IMG_STORE_GOOGLE_DE from '~/assets/images/stores/store-google.de.png';
import IMG_STORE_GOOGLE_FR from '~/assets/images/stores/store-google.fr.png';
import IMG_STORE_GALAXY_KO from '~/assets/images/stores/store-galaxy.ko.png';
import IMG_STORE_GALAXY_EN from '~/assets/images/stores/store-galaxy.en.png';
import IMG_STORE_GALAXY_JA from '~/assets/images/stores/store-galaxy.ja.png';
import IMG_STORE_GALAXY_ZH from '~/assets/images/stores/store-galaxy.zh-hant.png';
import IMG_STORE_GALAXY_TH from '~/assets/images/stores/store-galaxy.th.png';
import IMG_STORE_GALAXY_DE from '~/assets/images/stores/store-galaxy.de.png';
import IMG_STORE_GALAXY_FR from '~/assets/images/stores/store-galaxy.fr.png';
import IMG_STORE_ONE_KO from '~/assets/images/stores/store-one.ko.png';
import IMG_STORE_ONE_EN from '~/assets/images/stores/store-one.en.png';
import IMG_STORE_ONE_ZH from '~/assets/images/stores/store-one.zh-hant.png';

import { useFrontmatter } from '~/shared/contexts/frontmatter';
import { rem } from 'polished';
import styled from '@emotion/styled';
import { css } from '~/css';
import cn from '~/shared/utils/cn';

type StoreKey = 'apple' | 'google' | 'galaxy' | 'one';
interface StoreData {
  url: string;
  images: Record<string, string>;
}

const STORES: Record<StoreKey, StoreData> = {
  apple: {
    url: 'https://apps.apple.com/app/:id',
    images: {
      ko: IMG_STORE_APPLE_KO,
      en: IMG_STORE_APPLE_EN,
      ja: IMG_STORE_APPLE_JA,
      'zh-Hant': IMG_STORE_APPLE_ZH,
      th: IMG_STORE_APPLE_TH,
      de: IMG_STORE_APPLE_DE,
      fr: IMG_STORE_APPLE_FR,
    },
  },
  google: {
    url: 'https://play.google.com/store/apps/details',
    images: {
      ko: IMG_STORE_GOOGLE_KO,
      en: IMG_STORE_GOOGLE_EN,
      ja: IMG_STORE_GOOGLE_JA,
      'zh-Hant': IMG_STORE_GOOGLE_ZH,
      th: IMG_STORE_GOOGLE_TH,
      de: IMG_STORE_GOOGLE_DE,
      fr: IMG_STORE_GOOGLE_FR,
    },
  },
  galaxy: {
    url: '## Not Use',
    images: {
      ko: IMG_STORE_GALAXY_KO,
      en: IMG_STORE_GALAXY_EN,
      ja: IMG_STORE_GALAXY_JA,
      'zh-Hant': IMG_STORE_GALAXY_ZH,
      th: IMG_STORE_GALAXY_TH,
      de: IMG_STORE_GALAXY_DE,
      fr: IMG_STORE_GALAXY_FR,
    },
  },
  one: {
    url: 'https://onesto.re/:id',
    images: {
      ko: IMG_STORE_ONE_KO,
      en: IMG_STORE_ONE_EN,
      'zh-Hant': IMG_STORE_ONE_ZH,
    },
  },
};

function StoreButtons() {
  const frontmatter = useFrontmatter();
  const stores = (
    [
      { type: 'apple', id: frontmatter.appleAppId },
      { type: 'google', id: frontmatter.googleAppId },
      { type: 'one', id: frontmatter.onestoreAppId },
      { type: 'galaxy', id: frontmatter.galaxystoreUrl },
    ] satisfies { type: StoreKey; id: string | undefined }[]
  ).filter(({ id }) => id);

  function getUrl(type: StoreKey, id: string) {
    if (/https?:\/\//.test(id)) {
      return id;
    }

    const url = new URL(STORES[type].url, 'https://example.com');
    if (url.pathname.includes(':id')) {
      url.pathname = url.pathname.replace(':id', id!);
    } else {
      url.searchParams.set('id', id!);
    }

    return url.toString();
  }

  return (
    <Wrapper>
      {stores.map(({ type, id }) => {
        const url = getUrl(type, id!);

        return (
          <a key={type} href={url} target='_blank' rel='noopener noreferrer'>
            <img src={STORES[type].images[frontmatter.locale]} alt={`${type} Store`} height={64} />
          </a>
        );
      })}
    </Wrapper>
  );
}

export default StoreButtons;

const Wrapper = styled.section(
  css({
    display: 'flex',
    gap: [rem(10), rem(16)],
    justifyContent: 'center',
    alignItems: 'center',
    boxSizing: 'border-box',
    paddingInline: [rem(38), rem(16)],
    width: '100%',
    flexWrap: 'wrap',
    '& a': {
      lineHeight: 0,
    },

    '& img': {
      height: [rem(40), rem(64)],
    },
  }),
);
